(() => {
  if (window.__MF_BEANIE_VARIANT_BRIDGE__) return;
  window.__MF_BEANIE_VARIANT_BRIDGE__ = true;

  const VARIANT_IDS = Object.freeze({
    'Schwarz': 52183172874587,
    'Dunkelgrün': 53861971525979,
    'Blau': 53861971558747,
    'Rot': 53861971591515,
    'Grau': 53861971624283,
    'Neonpink': 53861971657051,
    'Hellgrün': 53861971689819,
    'Orange': 53861971722587,
    'Lila': 53861971755355,
    'Rosa': 53861971788123
  });

  const previousFetch = window.fetch.bind(window);
  window.fetch = async function mfBeanieVariantFetch(input, init = {}) {
    try {
      const url = typeof input === 'string' ? input : String(input?.url || '');
      const method = String(init?.method || 'GET').toUpperCase();
      const body = init?.body;
      if (method === 'POST' && /\/cart\/add\.js(?:\?|$)/.test(url) && body instanceof FormData && String(body.get('properties[Personalisierung]') || '') === 'Beanie-Designer') {
        const shell = document.querySelector('[data-mf-beanie-shell]');
        const color = shell?.dataset?.mfBeanieColor || 'Schwarz';
        const variantId = VARIANT_IDS[color];
        if (variantId) {
          body.set('id', String(variantId));
          body.set('properties[Beanie-Farbe]', color);
        } else {
          console.error('[MF Beanie] Keine Shopify-Variante für Farbe gefunden:', color);
        }
      }
    } catch (error) {
      console.warn('[MF Beanie] Varianten-Verknüpfung konnte nicht angewendet werden', error);
    }
    return previousFetch(input, init);
  };
})();
